import { render, staticRenderFns } from "./JobError.vue?vue&type=template&id=81df0130&scoped=true&"
import script from "./JobError.vue?vue&type=script&lang=js&"
export * from "./JobError.vue?vue&type=script&lang=js&"
import style0 from "./JobError.vue?vue&type=style&index=0&id=81df0130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df0130",
  null
  
)

export default component.exports